import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form } from '@unform/web';
import { BsQuestionCircle, BsXCircle, BsX, BsPencil, BsSearch } from 'react-icons/bs';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CPF from 'cpf';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import * as Yup from 'yup';

import { Scope } from '@unform/core';
import { RiSave2Line } from 'react-icons/ri';

import getValidationErrors from '~/utils/getValidationErrors';
import { lower } from '~/utils/lower';

import Index from '~/pages/Index';

import { ReactComponent as MusicIcon } from '~/assets/img/musicIcon.svg';
import loadingGif from '~/assets/img/loadingMusic.gif';

import { useProfile } from '~/hooks/profile';
import { useToast } from '~/hooks/toast';

import Loading from '~/components/Loading';
import Input from '~/components/Input';
import Posts from '~/components/Posts';
import Modal from '~/components/Modal';
import InputM from '~/components/InputM';
import ShowError from '~/components/ShowError';
import Checkbox from '~/components/Checkbox';
import TermsUse from '~/components/TermsUse';

import { apiNew } from '~/services/api';
import { formatTextCapitalize } from '~/utils/formatTextCapitalize';
import { removeEmojis } from 'src/utils/formatTextLetters.js';
import { useCreateMusicMutation, useFindMusicStylesQuery } from '../../graphql/generated/graphql.tsx';
import * as S from './styles';

export default function Data() {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const { dataPerson, dataProfile, profileComplete } = useProfile();
  const { addToast } = useToast();
  const [createMusic] = useCreateMusicMutation();
  const { data: musicStylesData } = useFindMusicStylesQuery();
  const [word, setWord] = useState('');
  const [genre, setGenre] = useState([]);
  const [genreID, setGenreID] = useState([]);
  const genreMusic = musicStylesData?.findMusicStyles ?? [];
  const [modalShow, setModalShow] = useState('');
  const [active, setActive] = useState('');
  const [name, setName] = useState('');
  const [erro, setErro] = useState(false);
  const [failLetterAndMusic, setFailLetterAndMusic] = useState(false);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [letters, setLetters] = useState('');
  const [countCoID, setCountCoID] = useState(1);
  const [countInID, setCountInID] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [pendingSubmission, setPendingSubmission] = useState(null);
  const [letterExpanded, setLetterExpanded] = useState(false);
  const [values, setValues] = useState({
    co_author: [],
    interpreter: [],
  });

  useEffect(() => {
    if (loadingRegister) {
      setModalShow('registeringMusic');
    } else {
      setModalShow('');
    }
  }, [loadingRegister]);

  const addInputcoAutor = e => {
    e.preventDefault();
    setCountCoID(countCoID + 1);
    setValues({
      ...values,
      co_author: [
        ...values.co_author,
        { id: countCoID, name: '', cpf: '' },
      ],
    });
  };

  const addInputcoAutorName = (e, position) => {
    const { value } = e.target;
    const newNameCoAuthor = values.co_author.map((wek, index) =>
      position === index ? { ...wek, name: value } : wek
    );
    setValues({ ...values, co_author: newNameCoAuthor });
  };

  const addInputcoAutorCPF = (e, position) => {
    const CPFnotCaracters = e.target.value.replace(/[^0-9]/g, '');
    const newCPFCoAuthor = values.co_author.map((wek, index) =>
      position === index ? { ...wek, cpf: CPFnotCaracters } : wek
    );
    setValues({ ...values, co_author: newCPFCoAuthor });
  };

  const addInputInterpreter = e => {
    e.preventDefault();
    setCountInID(countInID + 1);
    setValues({
      ...values,
      interpreter: [
        ...values.interpreter,
        { id: countInID, name: '', cpf: '' },
      ],
    });
  };

  const addInputInterpreterName = (e, position) => {
    const { value } = e.target;
    const newNameInterpreter = values.interpreter.map((wek, index) =>
      position === index ? { ...wek, name: value } : wek
    );
    setValues({ ...values, interpreter: newNameInterpreter });
  };

  const addInputInterpreterCPF = (e, position) => {
    const CPFnotCaracters = e.target.value.replace(/[^0-9]/g, '');
    const newCPFInterpreter = values.interpreter.map((wek, index) =>
      position === index ? { ...wek, cpf: CPFnotCaracters } : wek
    );
    setValues({ ...values, interpreter: newCPFInterpreter });
  };

  const removeInputcoAutor = position => {
    setValues({
      ...values,
      co_author: values.co_author.filter((_, index) => index !== position),
    });
  };

  const removeInputInterpreter = position => {
    setValues({
      ...values,
      interpreter: values.interpreter.filter((_, index) => index !== position),
    });
  };

  useEffect(() => {
    if (!profileComplete) {
      navigate('/dashboard/perfil');
    } else if (dataProfile.wallet?.creditUsed <= 0) {
      navigate('/dashboard/adicionar-creditos/planos');
    }
  }, [profileComplete, dataProfile, navigate]);

  const addGenreMusic = (idGenre, nameGenre) => {
    setGenreID(idGenre);
    setGenre([nameGenre]);
    setActive(nameGenre);
    setErro(false);
  };

  const removeGenreMusic = position => {
    setGenre(genre.filter((_, index) => index !== position));
    setActive('');
    setGenreID('');
  };

  const handleFileChange = e => {
    const { files } = e.target;
    const file = files[0];

    if (!file) {
      setSelectedFile(null);
      setName('');
      return;
    }

    const extension = file.name.split('.').pop().toLowerCase();

    if (extension === 'mp4') {
      addToast({
        type: 'error',
        title: 'Formato do áudio não é aceito',
        description:
          'Converta o áudio para o formato mp3 e tente novamente. Qualquer dúvida entre em contato com nosso suporte.',
      });
      return;
    }

    if (files.length > 1) {
      addToast({
        type: 'error',
        title: 'Múltiplos arquivos',
        description: 'Selecione apenas um áudio',
      });
      return;
    }

    const tenMB = 10485760;

    if (file.size > tenMB) {
      addToast({
        type: 'error',
        title: 'Arquivo muito grande',
        description: 'O áudio deverá ter até 10 MB',
      });
      return;
    }

    if (!file.type.startsWith('audio/')) {
      addToast({
        type: 'error',
        title: 'Tipo de arquivo inválido',
        description: 'Selecione apenas arquivos de áudio com a extensão .mp3',
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = event => {
      setSelectedFile({
        file,
        music: event.target.result,
        urlMP3: URL.createObjectURL(file),
      });
    };
    reader.readAsDataURL(file);

    setName(file.name);
  };

  /**
   * Processa o texto da letra: remove emojis, tags HTML, normaliza
   * espaços e quebras de linha. Retorna um array de linhas.
   */
  const processLettersText = rawText => {
    if (!rawText || rawText.trim() === '') return [''];

    const textWithoutEmojis = removeEmojis(rawText);
    const replaceText = textWithoutEmojis.replace(/(<([^>]+)>)/gi, '\n');

    let lines = replaceText.split('\n').map(line => {
      const formatted = line.trimStart().replace(/\s{4,}/g, '###BREAK###').replace(/\s{2,3}/g, ' ');
      return formatted;
    });

    lines = lines.join('\n').split('###BREAK###').join('\n').split('\n');

    while (lines.length > 0 && lines[0] === '') lines.shift();

    const result = [];
    let emptyCount = 0;

    for (let i = 0; i < lines.length; i++) {
      if (lines[i] === '') {
        emptyCount++;
        if (emptyCount <= 2) result.push(lines[i]);
      } else {
        emptyCount = 0;
        result.push(lines[i]);
      }
    }

    while (result.length > 0 && result[result.length - 1] === '') result.pop();

    return result;
  };

  const fecharSalvarLetter = () => {
    setModalShow('');
  };

  const handleSubmit = async formData => {
    try {
      formRef.current.setErrors({});

      const genero = genreID.length === 0 ? '' : genreID;

      /**
       * Remove entradas de coautor e intérprete onde nome E CPF estão
       * completamente em branco. O usuário não precisa ser bloqueado por
       * ter aberto o campo e não preenchido nada.
       */
      // formIndex preserva a posição original no array para mapear ao campo correto no unform
      const filteredCoAuthors = values.co_author
        .map((co, formIndex) => ({ ...co, formIndex, name: formatTextCapitalize(co.name) }))
        .filter(co => co.name.trim() || co.cpf.trim());

      const filteredInterpreters = values.interpreter
        .map((inter, formIndex) => ({ ...inter, formIndex, name: formatTextCapitalize(inter.name) }))
        .filter(inter => inter.name.trim() || inter.cpf.trim());

      const schema = Yup.object().shape({
        title: Yup.string().required('Título da música obrigatório.'),
        terms: Yup.boolean().oneOf(
          [true],
          'Você deve aceitar os termos e condições.'
        ),
        myAuthor: Yup.boolean().oneOf(
          [true],
          'Você deve aceitar para confirmar que a composição é de sua autoria.'
        ),
      });

      await schema.validate(formData, { abortEarly: false });

      if (genero === '') {
        addToast({
          type: 'error',
          title: 'Erro no registro',
          description: 'Você precisa preencher um estilo musical!',
        });
        return setErro(true);
      }
      setErro(false);

      const hasLetter = letters.trim() !== '';
      const hasAudio = !!selectedFile;

      if (!hasLetter && !hasAudio) {
        setFailLetterAndMusic(true);
        addToast({
          type: 'error',
          title: 'Erro no registro',
          description:
            'Você precisa adicionar pelo menos a letra ou o áudio da composição!',
        });
        return null;
      }
      setFailLetterAndMusic(false);

      const authorCPF = (dataPerson.cpf || '').replace(/[^0-9]/g, '');

      // Remove coautores com CPF igual ao do autor e mantém apenas o primeiro de cada CPF duplicado
      const seenCoAuthorCPFs = new Set();
      const uniqueCoAuthors = filteredCoAuthors.filter(co => {
        if (co.cpf === authorCPF || seenCoAuthorCPFs.has(co.cpf)) return false;
        seenCoAuthorCPFs.add(co.cpf);
        return true;
      });

      // Mantém apenas o primeiro intérprete de cada CPF duplicado
      const seenInterpreterCPFs = new Set();
      const uniqueInterpreters = filteredInterpreters.filter(inter => {
        if (seenInterpreterCPFs.has(inter.cpf)) return false;
        seenInterpreterCPFs.add(inter.cpf);
        return true;
      });

      for (let i = 0; i < uniqueCoAuthors.length; i++) {
        const co = uniqueCoAuthors[i];

        if (!co.name.trim()) {
          addToast({
            type: 'error',
            title: 'Erro no registro',
            description: `Informe o nome do coautor ${co.formIndex + 1}.`,
          });
          return formRef.current.setFieldError(`co_author_${co.formIndex}.name`, 'Nome é obrigatório');
        }

        if (!CPF.isValid(co.cpf, true)) {
          addToast({
            type: 'error',
            title: 'Erro no registro',
            description: 'Você precisa preencher todos os campos indicados!',
          });
          return formRef.current.setFieldError(
            `co_author_${co.formIndex}.cpf`,
            'CPF incompleto'
          );
        }

        if (!CPF.isValid(co.cpf)) {
          addToast({
            type: 'error',
            title: 'Erro no registro',
            description:
              'O CPF do coautor fornecido é inválido, tente novamente!',
          });
          return formRef.current.setFieldError(
            `co_author_${co.formIndex}.cpf`,
            'CPF inválido'
          );
        }
      }

      for (let i = 0; i < uniqueInterpreters.length; i++) {
        const inter = uniqueInterpreters[i];

        if (!inter.name.trim()) {
          addToast({
            type: 'error',
            title: 'Erro no registro',
            description: `Informe o nome do intérprete ${inter.formIndex + 1}.`,
          });
          return formRef.current.setFieldError(`interpreter_${inter.formIndex}.name`, 'Nome é obrigatório');
        }

        if (!CPF.isValid(inter.cpf, true)) {
          addToast({
            type: 'error',
            title: 'Erro no registro',
            description: 'Você precisa preencher todos os campos indicados!',
          });
          return formRef.current.setFieldError(
            `interpreter_${inter.formIndex}.cpf`,
            'CPF incompleto'
          );
        }

        if (!CPF.isValid(inter.cpf)) {
          addToast({
            type: 'error',
            title: 'Erro no registro',
            description:
              'O CPF do intérprete fornecido é inválido, tente novamente!',
          });
          return formRef.current.setFieldError(
            `interpreter_${inter.formIndex}.cpf`,
            'CPF inválido'
          );
        }
      }

      // Todas as validações passaram — armazena os dados e abre a modal de confirmação
      const titleWithoutEmojis = removeEmojis(String(formData.title).trim());
      const processedLetter = hasLetter ? processLettersText(letters) : [''];

      setLetterExpanded(false);
      setPendingSubmission({
        title: titleWithoutEmojis,
        genero,
        genreName: genre[0] || '',
        processedLetter,
        hasLetter,
        hasAudio,
        audioFileName: selectedFile?.file?.name || '',
        coAuthors: uniqueCoAuthors.map(({ id, name: coName, cpf }) => ({ id, name: coName, cpf })),
        interpreters: uniqueInterpreters.map(({ id, name: interName, cpf }) => ({ id, name: interName, cpf })),
      });

      setModalShow('confirmRegistration');
      return null;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRef.current.setErrors(errors);
      }

      setLoadingRegister(false);

      addToast({
        type: 'error',
        title: 'Erro no registro',
        description:
          'Falha no registro da música, revise todos os campos caso persista entre em contato com nosso suporte!',
      });
      return null;
    }
  };

  const formatCPFDisplay = cpf => {
    const digits = cpf.replace(/[^0-9]/g, '');
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const executeRegistration = async () => {
    if (!pendingSubmission) return;

    setModalShow('');
    setLoadingRegister(true);

    try {
      let musicFileId = null;

      if (selectedFile && selectedFile.file) {
        try {
          const data = new FormData();
          data.append('name', String(name).replace(/\.[^/.]+$/, ''));
          data.append('audio', selectedFile.file);

          const successUpload = await apiNew.post('/music/upload', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          musicFileId = successUpload.data.fileId;
        } catch (uploadError) {
          addToast({
            type: 'error',
            title: 'Erro no upload do áudio',
            description: 'Falha ao fazer upload do arquivo de áudio. Tente novamente.',
          });
          setLoadingRegister(false);
          return;
        }
      }

      const result = await createMusic({
        variables: {
          data: {
            title: pendingSubmission.title,
            styles: parseInt(pendingSubmission.genero, 10),
            letter: pendingSubmission.processedLetter,
            music_file_id: musicFileId,
            co_author: pendingSubmission.coAuthors,
            interpreter: pendingSubmission.interpreters,
          },
        },
      });

      setLoadingRegister(false);

      if (result.data?.createMusic) {
        addToast({
          type: 'success',
          title: 'Música registrada com sucesso!',
          description: 'Sua música foi registrada e está sendo processada.',
        });

        document.location.href = `${process.env.REACT_APP_URL}/dashboard/registrar-musica/registro-enviado`;
      }
    } catch (error) {
      setLoadingRegister(false);

      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((graphQLError, index) => {
          addToast({
            type: 'error',
            title: `Erro GraphQL ${index + 1}`,
            description: graphQLError.message,
          });
        });
      } else if (error.networkError) {
        addToast({
          type: 'error',
          title: 'Erro de conexão',
          description: 'Falha na conexão com o servidor GraphQL',
        });
      } else {
        addToast({
          type: 'error',
          title: 'Erro desconhecido',
          description: error.message || 'Erro inesperado ao registrar música',
        });
      }
    }
  };

  return (
    <Index>
      <Posts />
      <S.BackgroundSection className="blockPage">
        <h1>Registro de música:</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <div className="oneInputsRow">
            <Input label="Título da música:" type="name" maxLength={60} name="title" />
          </div>
          <div className="twoInputsRow">
            <div className="divColumn">
              <Input
                label="Autor da música:"
                type="text"
                name="name_author"
                value={dataPerson.fullname || ''}
                disabled
                style={{ cursor: 'no-drop', color: '#7C7C7D' }}
              />
            </div>
            <div className="divColumn">
              <InputM
                label="CPF do Autor:"
                mask="999.999.999-99"
                type="text"
                name="CPF_author"
                value={dataPerson.cpf || ''}
                disabled
                style={{ cursor: 'no-drop', color: '#7C7C7D' }}
              />
            </div>
          </div>

          <div className="hr">
            <div className="buttonsInserts">
              <button type="button" onClick={addInputcoAutor}>
                + Inserir coautor
              </button>
            </div>

            {values.co_author.map((coauthor, index) => (
              <div className="twoInputsRow" key={coauthor.id}>
                <Scope path={`co_author_${index}`}>
                  <div className="divAddColumn">
                    <Input
                      label={`Coautor ${index + 1} :`}
                      type="text"
                      name="name"
                      textTranform="capitalize"
                      onChange={e => addInputcoAutorName(e, index)}
                    />
                  </div>

                  <div className="divAddColumn">
                    <InputM
                      label={`CPF do Coautor ${index + 1} :`}
                      type="text"
                      name="cpf"
                      mask="999.999.999-99"
                      onChange={e => addInputcoAutorCPF(e, index)}
                    />
                  </div>

                  <button
                    type="button"
                    aria-label="Remover Coautor"
                    onClick={() => removeInputcoAutor(index)}
                  >
                    <BsXCircle />
                  </button>
                </Scope>
              </div>
            ))}
          </div>

          <div className="hr">
            <div className="buttonsInserts">
              <button type="button" onClick={addInputInterpreter}>
                + Inserir intérprete
              </button>
            </div>

            {values.interpreter.map((interpreter, index) => (
              <div className="twoInputsRow" key={interpreter.id}>
                <Scope path={`interpreter_${index}`}>
                  <div className="divAddColumn">
                    <Input
                      label={`Intérprete ${index + 1} :`}
                      type="text"
                      name="name"
                      textTranform="capitalize"
                      onChange={e => addInputInterpreterName(e, index)}
                    />
                  </div>
                  <div className="divAddColumn">
                    <InputM
                      label={`CPF do Intérprete ${index + 1} :`}
                      type="text"
                      name="cpf"
                      mask="999.999.999-99"
                      onChange={e => addInputInterpreterCPF(e, index)}
                    />
                  </div>

                  <button
                    type="button"
                    aria-label="Remover intérprete"
                    onClick={() => removeInputInterpreter(index)}
                  >
                    <BsXCircle />
                  </button>
                </Scope>
              </div>
            ))}
          </div>

          <div className="divAlignItems">
            <div className="styleMusic">
              <span>Pesquise o estilo musical e clique para selecionar:</span>
              <div className="inputIcon">
                <input
                  type="text"
                  value={word}
                  placeholder="Pesquisar"
                  onChange={e => setWord(e.target.value)}
                />
                <BsSearch size={13} />
              </div>
              {erro && (
                <ShowError description="Selecione um estilo músical abaixo" />
              )}
              <div className="genre">
                {genre.map((music, index) => (
                  <div key={music}>
                    <li>
                      {music}
                      <BsX onClick={() => removeGenreMusic(index)} />
                    </li>
                  </div>
                ))}
              </div>
            </div>

            <div className="alignTooltip">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Selecione o estilo musical da sua composição. Basta clicar
                    no balão abaixo.
                  </Tooltip>
                }
              >
                <span>
                  <BsQuestionCircle /> Saiba mais
                </span>
              </OverlayTrigger>
            </div>
          </div>

          <div className="genre">
            {genreMusic
              .filter(music => lower(music.name).includes(lower(word)))
              .map(music => (
                <div key={music.id}>
                  <button
                    className={active === music.name ? 'active' : ''}
                    type="button"
                    onClick={() => {
                      addGenreMusic(music.id, music.name);
                      setWord('');
                    }}
                  >
                    {music.name}
                  </button>
                </div>
              ))}
          </div>

          <S.SelectOption>
            <div
              className={failLetterAndMusic ? 'know active' : 'know'}
              id="myLetter"
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Clique em <strong>Digitar letra</strong> e digite sua
                    composição.
                  </Tooltip>
                }
              >
                <span className="know">
                  <BsQuestionCircle />
                  Saiba mais
                </span>
              </OverlayTrigger>
              <S.ButtonContainer
                onClick={() => setModalShow('write')}
                activeLetter={letters.trim() !== ''}
              >
                {letters.trim() === '' ? (
                  <>
                    <BsPencil /> <font className="let">Digitar letra</font>
                  </>
                ) : (
                  <span style={{ color: '#78e5d5' }}>Letra adicionada</span>
                )}
              </S.ButtonContainer>
            </div>

            <div className={failLetterAndMusic ? 'know active' : 'know'}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    Caso haja música, clique em{' '}
                    <strong>Selecione o áudio</strong> e faça o upload da sua
                    composição. A música deverá ter tamanho máximo de 10 MB.
                  </Tooltip>
                }
              >
                <span className="know">
                  <BsQuestionCircle />
                  Saiba mais
                </span>
              </OverlayTrigger>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <S.ButtonContainer activeLetter={!!selectedFile}>
                  <label htmlFor="selectMP3" className="selectMP3">
                    {!selectedFile ? (
                      <>
                        <MusicIcon />{' '}
                        <S.UploadMessage>
                          Selecione o áudio (máximo 10 MB)
                        </S.UploadMessage>
                        <input
                          type="file"
                          id="selectMP3"
                          onChange={handleFileChange}
                        />
                      </>
                    ) : (
                      <>
                        <S.UploadMessage type="success">
                          {String(selectedFile.file.name).replace(
                            /^(.{30}).*$/,
                            '$1...'
                          )}
                        </S.UploadMessage>
                        <input
                          type="file"
                          id="selectMP3"
                          onChange={handleFileChange}
                        />
                      </>
                    )}
                  </label>
                </S.ButtonContainer>
                {selectedFile && (
                  <div
                    style={{
                      border: '1px solid #87868b',
                      borderRadius: '6px',
                      padding: '10px',
                    }}
                  >
                    <span style={{ color: '#87868b' }}>
                      Escutar música escolhida:
                    </span>
                    <AudioPlayer
                      layout="horizontal"
                      customAdditionalControls={[]}
                      showJumpControls={false}
                      customVolumeControls={[]}
                      src={selectedFile.urlMP3}
                    />
                  </div>
                )}
              </div>
            </div>
          </S.SelectOption>

          <S.DivButton>
            <div className="checkbox">
              <Checkbox type="checkbox" name="terms">
                <span className="checkmark">
                  Aceito os{' '}
                  <button
                    className="termsButton"
                    type="button"
                    onClick={() => setModalShow('termsModal')}
                  >
                    termos e condições.
                  </button>
                </span>
              </Checkbox>
            </div>
            <div className="checkbox">
              <Checkbox type="checkbox" name="myAuthor">
                <span className="checkmark">
                  Declaro que essa composição é de minha autoria!
                </span>
              </Checkbox>
            </div>
            {loadingRegister ? (
              <img src={loadingGif} alt="Carregando..." width="50px" />
            ) : (
              <button type="submit" className="registerMusic">
                Registrar música
              </button>
            )}
          </S.DivButton>
        </Form>
      </S.BackgroundSection>

      {modalShow === 'registeringMusic' && (
        <Modal isOpen={modalShow}>
          <span style={{ margin: '0 auto', fontSize: '1.5rem' }}>
            Aguarde o registro da música
          </span>
          <Loading />
        </Modal>
      )}

      {modalShow === 'termsModal' && (
        <Modal isOpen={modalShow} onClickClose={() => setModalShow('')}>
          <TermsUse />
        </Modal>
      )}

      {modalShow === 'confirmRegistration' && pendingSubmission && (
        <Modal isOpen={modalShow} onClickClose={() => setModalShow('')}>
          <section className="confirmSection">
            <h2 style={{ marginBottom: '1.2rem', fontSize: '1.2rem', textAlign: 'center' }}>
              Confirme os dados do registro
            </h2>

            {(!pendingSubmission.hasLetter || !pendingSubmission.hasAudio) && (
              <S.ConfirmWarning>
                <span>⚠</span>
                <span>
                  {!pendingSubmission.hasLetter && !pendingSubmission.hasAudio
                    ? 'Este registro não terá letra nem áudio.'
                    : !pendingSubmission.hasLetter
                    ? 'Este registro não terá letra da música.'
                    : 'Este registro não terá arquivo de áudio.'}
                </span>
              </S.ConfirmWarning>
            )}

            <S.ConfirmTable>
              <tbody>
                <tr>
                  <th>Título</th>
                  <td>{pendingSubmission.title}</td>
                </tr>
                <tr>
                  <th>Estilo musical</th>
                  <td>{pendingSubmission.genreName}</td>
                </tr>
                <tr>
                  <th>Autor</th>
                  <td>{dataPerson.fullname} — {formatCPFDisplay(dataPerson.cpf || '')}</td>
                </tr>

                {pendingSubmission.coAuthors.length > 0 && (
                  <tr>
                    <th>Coautores</th>
                    <td>
                      {pendingSubmission.coAuthors.map((co, i) => (
                        <div key={co.id}>
                          {co.name} — {formatCPFDisplay(co.cpf)}
                          {i < pendingSubmission.coAuthors.length - 1 && <br />}
                        </div>
                      ))}
                    </td>
                  </tr>
                )}

                {pendingSubmission.interpreters.length > 0 && (
                  <tr>
                    <th>Intérpretes</th>
                    <td>
                      {pendingSubmission.interpreters.map((inter, i) => (
                        <div key={inter.id}>
                          {inter.name} — {formatCPFDisplay(inter.cpf)}
                          {i < pendingSubmission.interpreters.length - 1 && <br />}
                        </div>
                      ))}
                    </td>
                  </tr>
                )}

                <tr>
                  <th>Áudio</th>
                  <td style={{ color: pendingSubmission.hasAudio ? '#fafafa' : '#f0a04b' }}>
                    {pendingSubmission.hasAudio
                      ? pendingSubmission.audioFileName
                      : 'Não adicionado (O registro ficará sem áudio)'}
                  </td>
                </tr>
                <tr>
                  <th>Letra</th>
                  <td>
                    {pendingSubmission.hasLetter ? (
                      <>
                        <span style={{ color: '#fafafa', whiteSpace: 'pre-wrap' }}>
                          {letterExpanded
                            ? letters
                            : `${letters.slice(0, 120)}${letters.length > 120 ? '...' : ''}`}
                        </span>
                        {letters.length > 120 && (
                          <button
                            type="button"
                            onClick={() => setLetterExpanded(prev => !prev)}
                            style={{
                              display: 'block',
                              marginTop: '6px',
                              background: 'none',
                              border: 'none',
                              color: '#f34d21',
                              cursor: 'pointer',
                              padding: 0,
                              fontSize: '13px',
                            }}
                          >
                            {letterExpanded ? 'Recolher' : 'Ver letra completa'}
                          </button>
                        )}
                      </>
                    ) : (
                      <span style={{ color: '#f0a04b' }}>Não adicionada (O registro ficará sem letra)</span>
                    )}
                  </td>
                </tr>
              </tbody>
            </S.ConfirmTable>

            <S.ConfirmActions>
              <button
                type="button"
                className="confirmBack"
                onClick={() => setModalShow('')}
              >
                Voltar e corrigir
              </button>
              <button
                type="button"
                className="confirmSubmit"
                onClick={executeRegistration}
              >
                Confirmar e registrar
              </button>
            </S.ConfirmActions>
          </section>
        </Modal>
      )}

      {modalShow === 'write' && (
        <Modal isOpen={modalShow} onClickClose={() => setModalShow('')}>
          <section className="letterSection">
            <div className="headerLetter">
              <span>Digitar letra da música</span>
              <button type="button" onClick={fecharSalvarLetter}>
                <RiSave2Line size={22} />
                Salvar e voltar
              </button>
            </div>
            <div className="divLetterMusic">
              <textarea
                onChange={e => setLetters(e.target.value)}
                value={letters}
                cols="30"
                rows="30"
              />
            </div>
          </section>
        </Modal>
      )}
    </Index>
  );
}
